import GroupIcon from '@mui/icons-material/Group';
import { ComparisonBar } from './ComparisonBar';
import { SourceLegend } from './SourceLegend';
import React from 'react';

interface DemandSourceWidgetProps {
  data: {
    agenda: number;
    walkIn: number;
  };
}

export const DemandSourceWidget: React.FC<DemandSourceWidgetProps> = ({
  data,
}) => {
  const { agenda, walkIn } = data;
  const total = agenda + walkIn;
  const agendaPercentage = total > 0 ? (agenda / total) * 100 : 0;
  const walkInPercentage = total > 0 ? (walkIn / total) * 100 : 0;

  return (
    <div className='bg-white rounded-2xl shadow-lg border border-slate-100 p-8 h-full flex flex-col hover:shadow-2xl transition-all duration-300 group'>
      <div className='flex items-center gap-3 mb-6'>
        <div className='p-3 rounded-xl bg-indigo-50 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-500'>
          <GroupIcon className='!w-5 !h-5' />
        </div>
        <div>
          <h3 className='text-base font-bold text-slate-500 uppercase tracking-wider'>
            Origen del Cliente
          </h3>
          <p className='text-xs text-slate-400 mt-0.5 font-medium'>
            Comparativa:{' '}
            <span className='text-indigo-500 font-bold'>Con Turno</span> vs{' '}
            <span className='text-amber-500 font-bold'>Sin Turno</span>
          </p>
        </div>
      </div>

      <p className='text-xs text-slate-400 mb-8 leading-relaxed'>
        Entiende el comportamiento de tus clientes:{' '}
        <strong className='text-indigo-500'>Agendados</strong> son quienes
        reservaron previamente, mientras que{' '}
        <strong className='text-amber-500'>Espontáneos</strong> llegaron
        directamente a la sucursal.
      </p>

      <div className='flex-1 flex flex-col justify-center gap-12'>
        <ComparisonBar
          agenda={agenda}
          walkIn={walkIn}
          agendaPercentage={agendaPercentage}
          walkInPercentage={walkInPercentage}
        />

        <SourceLegend
          total={total}
          agendaPercentage={agendaPercentage}
          walkInPercentage={walkInPercentage}
        />
      </div>
    </div>
  );
};
